export default {
      id: "icon--thumb-up-usage",
      viewBox: "0 0 31.8 31.2",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--thumb-up-usage",
      toString: function () {
        return this.url;
      }
    }